<sb-card>
  <div card-header>
    <h1>{{ 'nav.network.devices.details.activity' | translate }}</h1>
  </div>
  <div card-header-more class="tw-flex tw-gap-2">
    <div class="tw-flex">
      <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="from"
                                [ngClass]="{'alertbox': from && till && from?.value > till?.value}"
                                (modelChange)="handleDateChangeFrom($event)"></sb-local-date-time-input>

      <div *ngIf="from && till && from?.value > till?.value" class="alert alert-danger"
           style="font-size: .7rem;top: 60px">{{ 'lang.globals.dateWarning'|translate }}
      </div>
      <!--<div id="from-box" (click)="changeFrom()" class="cursor-pointer btn btn-outline-primary">
          &nbsp;&nbsp;{{getFrom()}} &nbsp;<fa-icon [icon]="'chevron-up'">
          </fa-icon>
      </div>-->
    </div>
    <div class="">
      <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="till"
                                (modelChange)="handleDateChangeTill($event)"></sb-local-date-time-input>
      <!--<div id="till-box" (click)="changeTill()" class="cursor-pointer btn btn-outline-primary">
          &nbsp;&nbsp;{{getTill()}} &nbsp;<fa-icon [icon]="'chevron-up'">
          </fa-icon>
      </div>-->
    </div>
    <button (click)="refresh()" class="cursor-pointer btn btn-primary">
      &nbsp;&nbsp;{{ 'lang.globals.search' | translate }} &nbsp;
    </button>
  </div>
  <div card-body>
    <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]">

      <sb-comp-heatmap-status [from]="from" [till]="till" [inputData]="onlineStateData"></sb-comp-heatmap-status>
      
      <sb-comp-airtime-data [hideDeviceCount]="true" [from]="from" [till]="till" [chartHeight]="300" [resolveInCom]="false"
                            [inputData]="airtimeData"
                            [halfHeight]="false"></sb-comp-airtime-data>
    </div>
  </div>
</sb-card>
